import Vue from 'vue'
import router from './router'
import VueScrollmagic from './plugin'
import vWow from 'v-wow'
import VueCarousel from 'vue-carousel'
import VueMouseParallax from 'vue-mouse-parallax'
import App from './App.vue'
import NProgress from 'nprogress'
import '../node_modules/nprogress/nprogress.css'

Vue.use(VueScrollmagic)
Vue.use(vWow)
Vue.use(VueCarousel)
Vue.use(VueMouseParallax)
Vue.config.productionTip = false
Vue.directive('data-img', function (value) {
})
let pageLoad = 1
let $body = document.querySelector('body')
router.beforeResolve((to, from, next) => {
  if (pageLoad) {
    if (to.name) {
      // console.log('beforeResolve')
    }
  }
  next()
})

router.afterEach((to, from) => {
  if (pageLoad) {
    setTimeout(function () {
      this.show = true
      // NProgress.done()
      pageLoad = 0
      // console.log("after resolved");
      var t = document.querySelector('html')
      t.classList.add('lc')
      t.classList.remove('loading')
      setTimeout(function () {        
        document.querySelector('.tib-loader').remove()
      }, 1000)
      // TweenLite.to("#path",1,{attr:{d:'M -44,-50 C -137.1,117.4 67.86,445.5 236,452 435.3,459.7 500.5,242.6 676,244 873.5,245.6 957,522.4 1154,594 1593,753.7 1793,226.3 1582,-126 1371,-478.3 219.8,-524.2 -44,-50 Z'}});
    }, 800)
  }
})

new Vue({
  router,
  render: h => h(App),
  data: {
    show: false
  },
  mounted: function () {
    this.$nextTick(function () {
      // this.endload = true;
      // console.log("next tick hree!!")
    })
    var t = document.querySelector('body')
    t.classList.add('inLoading')
  },
  methods: {
    createImageArray: function () {
      var t = this
      var e = document.querySelector('#app')
      // console.log(e);
    },
    displayLoader: function () {
      // console.log('display loader')
    },
    hideLoader: function () {
      // console.log('hide loader')
    },
    displayApp: function () {
      // console.log('display app')
    }
  },
  created: function () {
    this.displayLoader(),
    this.hideLoader(),
    this.displayApp()
  },
  ready: function () {
    alert('ready function called')
  }
}).$mount('#app')
